import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function Unauthorized() {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const from = params.get('from');

  return (
    <div style={{
      display: 'flex',
      height: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(to right, #dfe6f1, #f8f9fa)'
    }}>
      <div style={{
        background: 'white',
        padding: '32px',
        borderRadius: '12px',
        boxShadow: '0 6px 18px rgba(0,0,0,0.15)',
        textAlign: 'center',
        maxWidth: '460px',
        width: '90%'
      }}>
        <h2 style={{ color: '#B22222', marginBottom: '10px' }}>Unauthorized</h2>
        <p style={{ color: '#666', marginBottom: '18px' }}>
          Your session is not authorized to access this resource.
        </p>
        {/* Removed attempted path display */}
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <button onClick={() => navigate('/')} style={{
            backgroundColor: '#00008B', color: 'white', padding: '10px 16px',
            border: 'none', borderRadius: '6px', cursor: 'pointer'
          }}>Go to Login</button>
        </div>
      </div>
    </div>
  );
}


